import { AcademicCapIcon, FolderIcon, RectangleGroupIcon } from "@heroicons/react/24/solid";
import { HomeIcon } from "@heroicons/react/20/solid";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { NavLink } from "@/components/ui/navigation";

/*
 * Sidebar component
 */
export const Sidebar = () => {
  /* Render */
  return (
    <div className="flex flex-col gap-1 w-44 min-w-44">
      <NavLink href="/">
        <HomeIcon className="size-5" /> Home
      </NavLink>
      <NavLink href="/projects">
        <FolderIcon className="size-5" /> Projects
      </NavLink>
      <NavLink href="/contexts">
        <RectangleGroupIcon className="size-5" /> Contexts
      </NavLink>
      <a
        href="https://academy.dragonflyai.co/en/collections/11846764-studio-3-0"
        target="_blank"
        rel="noreferrer"
        className="flex flex-row gap-2 p-2 btn btn-ghost items-center justify-start text-sm min-h-10 h-10 max-h-10"
      >
        <AcademicCapIcon className="size-5" /> Learn <ArrowTopRightOnSquareIcon className="size-5 text-base-content/50 ml-auto" />
      </a>
    </div>
  );
};
